import { motion } from 'framer-motion';
import './LoadingSpinner.css';

function LoadingSpinner({ size = 'medium', color = 'primary' }) {
  const sizes = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12'
  };

  const colors = {
    primary: 'border-primary-green',
    white: 'border-white',
    dark: 'border-text-dark'
  };

  return (
    <motion.div 
      className={`loading-spinner ${sizes[size]}`}
      animate={{ rotate: 360 }}
      transition={{
        duration: 1,
        repeat: Infinity,
        ease: "linear"
      }}
    >
      <div className={`spinner ${colors[color]}`}></div>
    </motion.div>
  );
}

export default LoadingSpinner; 